// eslint-disable-next-line
import React, { Component, Fragment } from 'react';
import { Badge, Button, Card, CardBody, CardSubtitle, Form, FormGroup, Input, Label, Modal, ModalFooter, ModalHeader } from 'reactstrap';
import { ArcaHttpSystem } from '../../../code/ArcaHttpSystem';
import { ModalPopup } from '../ModalPopup';

export class CalendarSession extends Component {

    constructor(props) {
        super(props);

        let key = this.props.text + '-' + this.props.date.JavaScriptDate.toLocaleDateString()
        let slot = this.props.slots[key]

        this.state = {
            width: '75px',
            height: '30px',
            isLater: this.props.today.IsLater(this.props.date),
            isSameDay: this.props.today.IsSameDate(this.props.date),
            key,
            isPopupVisible: false,
            showWeekendPopup: false,
            text: this.getText(slot),
            slot,
            activities: this.props.activities,
            isWeekend: this.props.date.DayOfWeek === 'Saturday' || this.props.date.DayOfWeek === 'Sunday',
        };
    }

    getText(slot) {
          return slot === undefined
            ? this.props.text
            : slot.Activity !== null
                ? slot.Activity
                : slot.Slotname;
    }

    render() {
        let { isPopupVisible, isLater, isSameDay, width, height, isWeekend, showWeekendPopup } = this.state;
        let { date, slots, activities } = this.props;

        let slot = slots[this.state.key]
        let text = this.getText(slot);

        let colour = slot
            ? slot.Added
                ? "success"
                : slot.Removed
                    ? "danger"
                    : "primary"
            : isLater
                ? "secondary"
                : "info"

        if (slot !== undefined)
            ArcaHttpSystem.Log(`[${this.state.key}]selected: ${slot?.Selected}, added ${slot?.Added}, removed ${slot?.Removed} `)

        return (
            <Fragment>
                <Badge
                    color={colour}
                    style={{
                        'width': width,
                        'height': height,
                        'textAlign': 'center',
                        'verticalAlign': 'middle',
                        'paddingTop': '10px',
                        'cursor': (isLater || isSameDay
                            ? 'pointer'
                            : 'default')
                    }}
                    onClick={(isLater || slot?.Removed)
                        ? this.onWeekendPopupConfirm.bind(this)
                        : isSameDay ? this.props.onClick.bind(this) : null}>
                    {text}

                </Badge>
                {isPopupVisible
                    ? <Modal isOpen={true}>
                        <ModalHeader>
                            {'Required Service..'}
                        </ModalHeader>

                        {activities
                            ? <Card>
                                <CardBody>
                                    <CardSubtitle>
                                        {`Please select service you require for your booking in the '` + text + `' slot on ` + date.DayAndMonthPretty}
                                    </CardSubtitle>
                                    <br/>
                                    <Form>
                                        {activities.map((i, key) =>
                                            <FormGroup key={key} check>
                                                <Label
                                                    onClick={this.activitySelected.bind(this, i.Code)}
                                                    check>
                                                    <Input type="radio" name={`radio${i.Activity}`} />
                                                    <p>{`${i.Value}`}</p>
                                                </Label>
                                            </FormGroup>
                                        )}
                                    </Form>
                                </CardBody>
                            </Card>
                            : null}

                        <ModalFooter>
                            <Button color="primary" onClick={() => this.setState({ isPopupVisible: false })}>Cancel</Button>
                        </ModalFooter>
                    </Modal>
                    : null}



                {showWeekendPopup ?? isWeekend
                    ? <ModalPopup
                        title={'Weekend bookings'}
                        text={'You have requested a weekend walk. Please be aware our walkers are not contracted to work weekends. A member of the team will be in touch if someone is avalible. Please note, additonal charges are applied.'}
                        onCancel={() => this.setState({ showWeekendPopup: false })}
                        onConfirm={() => this.tabClicked()} />
                    : null}
            </Fragment>
        );
    }

    onWeekendPopupConfirm() {
        if (this.state.isWeekend) {
            this.setState({
                showWeekendPopup: true
            })
            return;
        }

        this.tabClicked() 

    }

    tabClicked() {
        let { key } = this.state
        let { date, text, onClick, slots, activities } = this.props

        let slot = slots[key];
        let selected = slot ? !slot.Selected : true

        onClick(
            date,
            text,
            selected,
            null);

        if (activities && selected)
            this.setState({ isPopupVisible: true, showWeekendPopup : false })
    }

    activitySelected(code) {
        let { date, text } = this.props
        let { slot } = this.state

        this.props.onClick(
            date,
            text,
            !slot?.Selected,
            code);

        this.setState({
            isPopupVisible: false,
            text: code ?? this.state.code
        })
    }
}